export const GREENCODE = '#008000';
export const REDCODE = '#B20101';
export const AMBERCODE = '#FF9500';

export const colors = {
  green: '#008000',
  palePink: '#F7CED7',
  red: '#B20101',
  amber: '#FF9500',
  darkBlue: '#293462',
  typographySpace: '#444',
  typographyNero: '#222',
  typographyCloud: '#B6B6B4',
  tableGrey: '#FAFBFB',
  disabledGrey: '#D0D3D4',
  disabledGreyLight: '#E9EAEB',
  charcoal: '#252A36',
  charcoalTint80: '#D3D4D7',
  charcoalTint90: '#E9E9EB',
  white: '#fff',
  black: '#000',
  darkGrey: '#7D7C7C',
};
